module.exports = __webpack_public_path__ + "static/media/train_booking_logo.97b22dab.png";